import { render } from "./Recaptchav2Step.vue?vue&type=template&id=42b3bd29"
import script from "./Recaptchav2Step.vue?vue&type=script&lang=js"
export * from "./Recaptchav2Step.vue?vue&type=script&lang=js"

import "./Recaptchav2Step.vue?vue&type=style&index=0&id=42b3bd29&lang=css"

import exportComponent from "/data/vstsagent02/user/3807/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__